<template lang="pug">
.sns
  .sns-textarea
    h3
      | FOLLOW US
    p
      | 入校を検討されている方にもおすすめのイベント情報などを発信しております
    .x-link
      a(href="https://twitter.com/VookSchool" target="_blank")
        | @Vookschool
</template>

<script>
export default {
  mounted() {
    this.$nextTick(() => {
      const script = document.createElement('script')
      script.src = 'https://platform.twitter.com/widgets.js'
      script.async = true
      document.body.appendChild(script)
    })
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/individual/school/school2023.scss';
@import '~/assets/css/individual/school/plan.scss';
$gradation-text-start: #475cb8;
$gradation-text-end: #5cc9dc;
::v-deep {
  @import '~/assets/css/individual/school/school2023-hooper.scss';
}
.sns {
  max-width: 1240px;
  margin: 60px auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  @include media(sp) {
    display: block;
    padding: 0 10px;
    margin: 30px auto;
  }
  .sns-textarea {
    h3 {
      font-size: 32px;
      font-weight: 500;
      @include media(sp) {
        font-size: 24px;
      }
    }
    p {
      font-size: 16px;
      margin-top: 6px;
      @include media(sp) {
        font-size: 14px;
      }
    }
    .x-link {
      margin-top: 40px;
      a {
        position: relative;
        padding: 15px 60px 15px 80px;
        font-size: 14px;
        font-weight: 500;
        border: 3px solid #ccc;
        border-radius: 50px;
        text-decoration: none;
        box-shadow: 0 2px 8px -2px rgba(#525b6c, 0.3);
        background-color: #ffffff;
        &:hover {
          box-shadow: 0 0 10px 0 rgba(#000000, 0.2);
          transform: translate3d(0, 1px, 0);
          filter: brightness(80%);
        }
        &::before {
          content: '';
          display: inline-block;
          width: 20px;
          height: 20px;
          background-image: url('~//assets/images/school/motion-graphics/x-logo.png');
          background-size: contain;
          background-repeat: no-repeat;
          position: absolute;
          left: 50px;
          top: 50%;
          transform: translateY(-50%);
          @include media(sp) {
            left: 30%;
          }
        }
        @include media(sp) {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
}
</style>
